<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> Status:</label>
        <div class="input-group mb-3">
            <b-form-select v-model="form.statusImport.value" :options="form.statusImport.options" />
        </div>
        <label> Tipo da Planilha:</label>
        <div class="input-group mb-3">
            <b-form-select v-model="form.tipoPlanilha.value" :options="form.tipoPlanilha.options" />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-third w-100" v-on:click="onFilter">Filtrar</button>
      </div>
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-default w-100" v-on:click="onClearFilters">Limpar Filtros</button>
      </div>
    </div>
    <div class="form-group row" style="margin-top: 250px;">&nbsp;<!--Space to scroll--></div>
  </div>
</template>
<script>
import ManagerSearch from './search.js'
export default ManagerSearch

</script>



// WEBPACK FOOTER //
// src/views/private/import/components/search/search.vue